import { render, staticRenderFns } from "./importOrg.vue?vue&type=template&id=2abf7f44&scoped=true&"
import script from "./importOrg.vue?vue&type=script&lang=js&"
export * from "./importOrg.vue?vue&type=script&lang=js&"
import style0 from "./importOrg.vue?vue&type=style&index=0&id=2abf7f44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf7f44",
  null
  
)

export default component.exports